import {
  AbpApplicationConfigurationService,
  ConfigStateService,
  PermissionService,
} from '@abp/ng.core';
import { Component } from '@angular/core';
import { HttpErrorComponent } from '@volo/abp.ng.theme.lepton';

@Component({
  selector: 'cai-custom-http-error',
  templateUrl: './custom-http-error.component.html',
  standalone: false,
})
export class CustomHttpErrorComponent extends HttpErrorComponent {
  constructor(
    private abpApplicationConfigurationService: AbpApplicationConfigurationService,
    private config: ConfigStateService,
    private permissionService: PermissionService,
  ) {
    super();
  }

  goHome() {
    this.abpApplicationConfigurationService
      .get({ includeLocalizationResources: true })
      .subscribe((config) => {
        this.config.setState(config);

        const isAuthorized = this.permissionService.getGrantedPolicy('Designer.Projects');

        if (isAuthorized) {
          this.router.navigateByUrl('/projects', { onSameUrlNavigation: 'reload' });
        } else {
          this.router.navigateByUrl('/', { onSameUrlNavigation: 'reload' });
        }
        this.destroy$?.next();
      });
  }
}
